import { Component, OnInit, ViewChild } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDialog, MatPaginator, MatTableDataSource } from '@angular/material';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SharedService } from '../../../shared/shared.service';
import { SnackBarService } from '../../../common-services/snack-bar.service';
import { ActivatedRoute, Router } from '@angular/router';
import { map, startWith } from 'rxjs/operators';
import { isNullOrUndefined } from 'util';
import { ConfirmationHeader } from '../../../common-services/enum.service';
import { ButtonType } from '../../../common-component/confirmation-popup/confirmation-popup.component';
import { DateService } from '../../../common-services/common-functions.service';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { AuthService } from '../../../auth/auth.service';

export const DATE_MMYYYY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-loyalty-discount-configuration',
  templateUrl: './loyalty-discount-configuration.component.html',
  styleUrls: ['./loyalty-discount-configuration.component.css'],
  providers: [{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],},
    { provide: MAT_DATE_FORMATS, useValue: DATE_MMYYYY_FORMATS },]
  })
export class LoyaltyDiscountConfigurationComponent implements OnInit {
  // Comment: Added functionality for pagination
  // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  savebuttondisable: boolean = false;
  cancelbuttondisable: boolean = false;
  loyaltyDiscountform: FormGroup;
  pageProperties = {
    selectedRecord: null,
    selectedStoreDetails: null,
    selectedStore: null,
    tempRecord: null,
    paramId: 0
  }
  controldisable: boolean = false;
  storecodedisable: boolean = false;
  statelist: any[] = new Array<any>();

  stateitemControl = new FormControl();
  isAllSelectedState = false;
  selectedState: any[] = new Array<any>();
  stateremovable = true;
  filteredStateList: any[];
  IsActiveControlDisable: boolean = true;

  storeCategoryItemControl = new FormControl();
  isAllSelectedStoreCategory = false;
  selectedStoreCategory: any[] = new Array<any>();
  storeCategoryRemovable = true;
  filteredStoreCategoryList: any[];
  storeCategoryList: any;

  storecodeitemControl = new FormControl();
  isAllSelectedStore = false;
  selectedStore: any[] = new Array<any>();
  storecoderemovable = true;
  filteredStoreList: any[];
  storecodeList = [];

  // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025
  // productCategoryControl = new FormControl();
  // isAllSelectedProductCategory = false;
  // selectedProductCategory: any[] = new Array<any>();
  // productCategoryRemovable = true;
  // filteredProductCategoryList: any[];
  // productCategoryList = [];

  // productNameControl = new FormControl();
  // isAllSelectedProductName = false;
  // selectedProductName: any[] = new Array<any>();
  // productNameRemovable = true;
  // filteredProductNameList: any[];
  productNameList = [];

  storelastFilter = '';
  statelastFilter = '';
  storeCategorylastFilter = '';
  productCategorylastFilter = '';
  productNamelastFilter = '';

  todaydate: Date = null;
  setminfromdate: Date = null;
  setmintodate: Date = null;

  fromdatedisable = false;
  todatedisable = false;
  dialogRef: any;
  mappingList: Array<{stateId: number, storeCategoryId: number, storeCodeId: number, itemCategoryId: number}> = [];
  percentageValue: string;
  csvfileName: string;
  arrayOfObjects: any[] = [];  // To hold the parsed CSV data as an array of objects
  matchArrayOfObject: any[] = [];
  notMatchedArrayOfObjects: any[] = [];
  csvData: string = '';  // To store the CSV file content
  showModal: boolean = false;
  // columnHeaderForPopupMsg = [ 'Success Records', 'Failed Records', 'Total Records', 'Failed Record Items'];
  // columnsForPopupMsg = [ 'success_Records', 'failed_Records', 'total_Records', 'failed_Record_Items'];
  // dataForPopupMsg: any[] = new Array<any>();
  popupCaption: string = "Record's Status:";
  totalProductLength: number = 0;
  // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025
  uploadedFile: string = '';
  uploadedUserName: string = '';
  loyaltyItemDataSource = new MatTableDataSource<any>([]);
  tableObject = {
    // displayedColumns: ['srno', 'select', 'itemCode', 'categoryName', 'itemName', 'delete'],
    displayedColumns: ['srno', 'id', 'itemId', 'code','name', 'mm_McmId', 'mcm_Name'],
    // headerNames: ['Sr. No', 'Select', 'Product Code', 'Category Name', 'Product Name', 'Delete']
    headerNames: ['Sr. No', 'Product Id', 'item Id', 'Product Code', 'Product Name', 'Category Id', 'Category Name']
  };
  selectedItems = new Set<number>();
  totalRecordCount: number = 0;
  successRecordCount: number = 0;
  failureRecordCount: number = 0;
  failureRecords: string = '';
  // Column name to sort by
  sortColumn = 'srno';
  sortDirection: 'asc' | 'desc' = 'asc';
  // productStatus = "";
  // appliedOn = "";

  // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
  constructor(private fg: FormBuilder, 
    private sharedService: SharedService, 
    private notification: SnackBarService, 
    private activateRoute: Router, 
    private route: ActivatedRoute, 
    public dialog: MatDialog,
    private authService: AuthService,) {
      this.stateitemControl.valueChanges.pipe(
        startWith<string | any[]>(''),
        map(value => typeof value === 'string' ? value : this.statelastFilter),
        map(filter => this.statefilter(filter))
      ).subscribe(data => this.filteredStateList = data);

      this.storeCategoryItemControl.valueChanges.pipe(
        startWith<string | any[]>(''),
        map(value => typeof value === 'string' ? value : this.storeCategorylastFilter),
        map(filter => this.storeCategoryfilter(filter))
      ).subscribe(data => this.filteredStoreCategoryList = data);

      this.storecodeitemControl.valueChanges.pipe(
        startWith<string | any[]>(''),
        map(value => typeof value === 'string' ? value : this.storelastFilter),
        map(filter => this.storefilter(filter))
      ).subscribe(data => this.filteredStoreList = data);

      // this.productCategoryControl.valueChanges.pipe(
      //   startWith<string | any[]>(''),
      //   map(value => typeof value === 'string' ? value : this.productCategorylastFilter),
      //   map(filter => this.productCategoryfilter(filter))
      // ).subscribe(data => this.filteredProductCategoryList = data);

      // this.productNameControl.valueChanges.pipe(
      //   startWith<string | any[]>(''),
      //   map(value => typeof value === 'string' ? value : this.productNamelastFilter),
      //   map(filter => this.productNamefilter(filter))
      // ).subscribe(data => this.filteredProductNameList = data);

      route.params.subscribe((t) => {
        this.pageProperties.paramId = t['id'];
      });

      // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025
      this.uploadedUserName = this.authService.getUserName;
      this.loadProductName();
  }

  ngOnInit() {
    this.route.data.subscribe((t) => {
      if ((t.data.data.header != null || t.data.data.header != undefined)) {
        this.controldisable = true;
        this.cancelbuttondisable = true;
        this.savebuttondisable = true;
        this.bindForm(t.data.data.header);
        // this.loadState(t.data.data.mapping);

        if (t.data.data.statelist != null || t.data.data.statelist != undefined) {
          this.selectedState = t.data.data.statelist;
        }

        if (t.data.data.storeCategory != null || t.data.data.storeCategory != undefined) {
          t.data.data.storeCategory.forEach(element => {
            this.selectedStoreCategory.push(element);
          });
        }

        if (t.data.data.storeCode != null || t.data.data.storeCode != undefined) {
          t.data.data.storeCode.forEach(element => {
            this.selectedStore.push(element);
          });
        }

        // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
        if (t.data.data.product != null || t.data.data.product != undefined) {
          this.loyaltyItemDataSource.data = t.data.data.product;
        }

        // if (t.data.data.productCategory != null || t.data.data.productCategory != undefined) {
        //   t.data.data.productCategory.forEach(element => {
        //     this.selectedProductCategory.push(element);
        //   });
        // }

        // if (t.data.data.product != null || t.data.data.product != undefined) {
        //   t.data.data.product.forEach(element => {
        //     this.selectedProductName.push(element);
        //   });
        // }
      }
      else {
        this.bindForm(null);
        this.loadState('');
        // this.loadProductCategory();
        // this.loadProductName();
      }
    });

    this.loyaltyDiscountform.get("isActive").setValue(1);
    this.setmintodate = new Date();
    this.setminfromdate = new Date(new Date().getTime());
    this.todaydate = new Date();
    this.todaydate.setHours(0, 0, 0, 0);
  }

  onKeyPressValidation(event){
    return (event.charCode == 8 || event.charCode == 0) ? null : (event.charCode >= 48 && event.charCode <= 57 || event.charCode == 46) ;
  }

  // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
  sortData(column: string): void {
    if (this.sortColumn === column) {
      // If the same column is clicked, toggle the sort direction
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // If a different column is clicked, set ascending sort as default
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    // Perform sorting
    this.loyaltyItemDataSource.data.sort((a, b) => {
      if (a[column] < b[column]) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (a[column] > b[column]) {
        return this.sortDirection === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  loadState(Ids){
    this.sharedService.customGetApi('storeexeprocess/getallstatesandcity').subscribe((t: any) => {
      if (t && t.data) {
        this.statelist = t.data.statelist;
        this.filteredStateList = [];
        this.filteredStateList = this.statelist;
      }
    });
  }
  
  // loadProductCategory(){
  //   this.sharedService.customGetApi('loyaltyDiscount/getProductCategory').subscribe((t: any) => {
  //     if (t && t.data) {
  //       this.productCategoryList = t.data;
  //       this.filteredProductCategoryList = [];
  //       this.filteredProductCategoryList = this.productCategoryList;
  //     }
  //   });
  // }

  // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
  loadProductName(){
    // let prodCatids = this.selectedProductCategory.map(a => a.id).join();
    // const SaveEmployee = CommonService.copyObject(this.employeeForm.value);
    // this.sharedService.customPostApi('loyaltyDiscount/getProductName?prodIds=' + prodCatids, "").subscribe((t: any) => {
    this.sharedService.customPostApi('loyaltyDiscount/getProductName', "").subscribe((t: any) => {
      if (t && t.data) {
        this.productNameList = t.data;
        // if (prodCatids.length > 0) {
        //   this.filteredProductNameList = [];
        //   this.filteredProductNameList = this.productNameList;
        // }
        // else {
          this.totalProductLength = this.productNameList.length;
        // }
        // Comment: if data already selected then it should remain for particular category
        // this.selectedProductName.forEach(item =>{
        //   const findex = this.filteredProductNameList.findIndex(value => value.id === item.id);
        //   this.filteredProductNameList[findex].selected = true;
        // });
        // this.filteredProductNameList = Array.from({ length: 1000 }, (_, i) => `Item #${i + 1}`);
      }
    });
  }

  bindForm(selectData: any) {
    try {
      if (selectData) {
        this.pageProperties.selectedRecord = selectData;
      }
      else {
        this.pageProperties.selectedRecord = null;
      }
      this.loyaltyDiscountform = this.fg.group({
        'loyaltyDiscountId': [(selectData ? selectData.id : null), null],
        'loyaltyDesc': [(selectData ? selectData.description : null), [Validators.required]],
        'loyaltyFromDate': [(selectData ? new Date(new Date(selectData.from_Month).setHours(0, 0, 0, 0)) : new Date(new Date().setHours(0, 0, 0, 0))), [Validators.required]],
        'loyaltyToDate': [(selectData ? new Date(new Date(selectData.to_Month).setHours(0, 0, 0, 0)) : null), [Validators.required]],
        'isIncluded': [(selectData ? selectData.isIncluded : 0)],
        'isBeforeTax': [(selectData ? selectData.isBeforeTax : 0)],
        'totalMinimumBillDiscount': [selectData ? selectData.totalMinimumBillPerMonth : 0, [Validators.required]],
        'rewardPointPerc': [selectData ? selectData.rewardPointInPerc : 0, Validators.pattern(/^\d+(\.\d{0,2})?$/)],
        'perRewardPointValue': [selectData ? selectData.perRewardPointValueToRs : 0, [Validators.required]],
        'earningcycleinmonth': [selectData ? selectData.earningCycleInMonth : 0, [Validators.required]],
        'rewardPointExpiryDays': [selectData ? selectData.rewardPointExpDays : 0, [Validators.required]],
        'allowSalesReturn': [selectData ? selectData.includeReturn : 0],
        'isActive': [selectData ? selectData.isActive : 0]
        // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
        // ,
        // 'productNameControl': [''],
        // 'productCategoryControl': ['']
      });
    } catch (error) {
      console.log(error);
    }
  }

  // #Remove Logic Start For All Multi DropDown Start

  stateremove(item: any): void {
    const index = this.selectedState.findIndex(value => value.id === item.id);
    if (index >= 0) {
      this.selectedState.splice(index, 1);
      const findex = this.filteredStateList.findIndex(value => value.id === item.id);
      if (findex >= 0) {
        this.filteredStateList[findex].selected = false;
      }

      this.changeState(function (callback) {});
    }
    this.setStateselectall();
  }

  storeCategoryRemove(item: any): void {
    const index = this.selectedStoreCategory.findIndex(value => value.id === item.id);
    if (index >= 0) {
      this.selectedStoreCategory.splice(index, 1);
      const findex = this.filteredStoreCategoryList.findIndex(value => value.id === item.id);
      if (findex >= 0) {
        this.filteredStoreCategoryList[findex].selected = false;
      }
    }
    this.setstoreCategoryselectall();
  }

  storecoderemove(item: any): void {
    const index = this.selectedStore.findIndex(value => value.storeNo === item.storeNo);
    if (index >= 0) {
      this.selectedStore.splice(index, 1);
      const findex = this.filteredStoreList.findIndex(value => value.storeNo === item.storeNo);
      if (findex >= 0) {
        this.filteredStoreList[findex].selected = false;
      }
    }
    this.setStoreCodeselectall();
  }

  // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
  // productCategoryRemove(item: any): void {
  //   const index = this.selectedProductCategory.findIndex(value => value.id === item.id);
  //   this.selectedProductName = this.removeItemFromObjectArray(this.selectedProductName, this.filteredProductNameList, item.id, "mm_McmId", "selected", false, true);
  //   if (index >= 0) {
  //     this.selectedProductCategory.splice(index, 1);
  //     const findex = this.filteredProductCategoryList.findIndex(value => value.id === item.id);
  //     if (findex >= 0) {
  //       this.filteredProductCategoryList[findex].selected = false;
  //     }
  //   }
  //   // Comment: if seleted product category count is greater than zero then load product name else clear it
  //   if (this.selectedProductCategory.length === 0) {
  //     this.filteredProductNameList = [];
  //   }
    
  //   this.loadProductName();
  //   // this.setSelectAllProductCategory();
  // }

  // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
  // productNameRemove(item: any): void {
  //   const index = this.selectedProductName.findIndex(value => value.id === item.id);
  //   if (index >= 0) {
  //     this.selectedProductName.splice(index, 1);
  //     const findex = this.filteredProductNameList.findIndex(value => value.id === item.id);
  //     if (findex >= 0) {
  //       this.filteredProductNameList[findex].selected = false;
  //     }
  //   }
  //   // this.setSelectAllProductName();
  // }

  // Generic function to remove objects from array based on a dynamic property comparison
  removeItemFromObjectArray<T>(chipOfArr: T[], filterOfArr: T[], chipCompareValue: any, chipProperty: keyof T, setFilterProperty: keyof T, falseValue: any, trueValue: any): T[] {
    // Iterate backwards to avoid skipping elements after splice
    for (let i = chipOfArr.length - 1; i >= 0; i--) {
      if (chipOfArr[i][chipProperty] === chipCompareValue) {  // Compare the property with the dynamic value
        chipOfArr.splice(i, 1);  // Remove the object at the matching index
        filterOfArr.forEach(item => {
          if (item[setFilterProperty] === trueValue) {
            item[setFilterProperty] = falseValue;
          }
        });
      }
    }
    return chipOfArr;  // Return the updated array
  }

  // #Remove Logic Start For All Multi DropDown End

  // # Single Drop Down Selection Start

  stateOptionClicked(event: Event, item: any) {
    event.stopPropagation();
    this.statetoggleSelection(item);
  }

  storeCategoryOptionClicked(event: Event, item: any) {
    event.stopPropagation();
    this.storeCategorytoggleSelection(item);
  }

  storeOptionClicked(event: Event, item: any) {
    event.stopPropagation();
    this.storecodetoggleSelection(item);
  }
// Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
  // productCategoryOptionClicked(event: Event, item: any) {
  //   event.stopPropagation();
  //   this.productCategorytoggleSelection(item);
  // }

  // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
  // productNameOptionClicked(event: Event, item: any) {
  //   event.stopPropagation();
  //   this.productNametoggleSelection(item);
  // }

  // # Single Drop Down Selection End

  // # Toggle Selection Start

  statetoggleSelection(item: any) {
    item.selected = !item.selected;
    if (item.selected) {
      this.selectedState.push(item);
      this.changeState(function (callback) {})
    } else {
      const findex = this.filteredStateList.findIndex(value => value.id === item.id);
      if (findex >= 0) {
        this.filteredStateList[findex].selected = false;
      }
      const i = this.selectedState.findIndex(value => value.id === item.id);
      if (i >= 0) {
        this.selectedState.splice(i, 1);
      }
      this.changeState(function (callback) {});
      this.storecodeList = this.storecodeList.filter(e => e.state.toLowerCase() !== item.name.toLowerCase());
      this.selectedStore = this.selectedStore.filter(e => e.state.toLowerCase() !== item.name.toLowerCase());
      this.filteredStoreList = this.filteredStoreList.filter(e => e.state.toLowerCase() !== item.name.toLowerCase());
    }
    this.setStateselectall();
  }

  storeCategorytoggleSelection(item: any) {
    item.selected = !item.selected;
    if (item.selected) {
      this.selectedStoreCategory.push(item);
      this.storeCategorychange(function () {
      });
    } else {
      const findex = this.filteredStoreCategoryList.findIndex(value => value.id === item.id);
      if (findex >= 0) {
        this.filteredStoreCategoryList[findex].selected = false;
      }
      const i = this.selectedStoreCategory.findIndex(value => value.id === item.id);
      if (i >= 0) {
        this.selectedStoreCategory.splice(i, 1);
      }

      // this.storecodeList = this.storecodeList.filter(e => e.storeType.toLowerCase() !== item.storeType.toLowerCase());
      // this.selectedStore = this.selectedStore.filter(e => e.storeType.toLowerCase() !== item.storeType.toLowerCase());
      // this.filteredStoreList = this.filteredStoreList.filter(e => e.storeType.toLowerCase() !== item.storeType.toLowerCase());
    }
    this.setstoreCategoryselectall();
  }

  storecodetoggleSelection(item: any) {
    item.selected = !item.selected;
    if (item.selected) {
      this.selectedStore.push(item);
    } else {
      const findex = this.filteredStoreList.findIndex(value => value.storeNo === item.storeNo);
      if (findex >= 0) {
        this.filteredStoreList[findex].selected = false;
      }
      const i = this.selectedStore.findIndex(value => value.storeNo === item.storeNo);
      if (i >= 0) {
        this.selectedStore.splice(i, 1);
      }
    }
    this.setStoreCodeselectall();
  }

  // productCategorytoggleSelection(item: any) {
  //   item.selected = !item.selected;
  //   if (item.selected) {
  //     this.selectedProductCategory.push(item);
  //     this.changeProductCategory(function () {});
  //   } else {
  //     this.selectedProductName = this.removeItemFromObjectArray(this.selectedProductName, this.filteredProductNameList, item.id, "mm_McmId", "selected", false, true);
  //     const findex = this.filteredProductCategoryList.findIndex(value => value.id === item.id);
  //     if (findex >= 0) {
  //       this.filteredProductCategoryList[findex].selected = false;
  //     }
  //     const i = this.selectedProductCategory.findIndex(value => value.id === item.id);
  //     if (i >= 0) {
  //       this.selectedProductCategory.splice(i, 1);
  //     }
  //   }
  //   // this.setSelectAllProductCategory();
  // }

  // productNametoggleSelection(item: any) {
  //   item.selected = !item.selected;
  //   if (item.selected) {
  //     this.selectedProductName.push(item);
  //   } else {
  //     const findex = this.filteredProductNameList.findIndex(value => value.id === item.id);
  //     if (findex >= 0) {
  //       this.filteredProductNameList[findex].selected = false;
  //     }
  //     const i = this.selectedProductName.findIndex(value => value.id === item.id);
  //     if (i >= 0) {
  //       this.selectedProductName.splice(i, 1);
  //     }
  //   }
  //   // this.setSelectAllProductName();
  // }

  // # Toggle Selection End

  // # Set Selection All Start

  setStateselectall() {
    const allitemcount = this.statelist.length;
    const checkeditemcount = this.filteredStateList.filter(x => x.selected === true).length;
    this.isAllSelectedState = (allitemcount === checkeditemcount ? true : false);
  }

  setstoreCategoryselectall() {
    const allitemcount = this.storeCategoryList.length;
    const checkeditemcount = this.filteredStoreCategoryList.filter(x => x.selected === true).length;
    this.isAllSelectedStoreCategory = (allitemcount === checkeditemcount ? true : false);
  }

  setStoreCodeselectall() {
    const allitemcount = this.storecodeList.length;
    const checkeditemcount = this.filteredStoreList.filter(x => x.selected === true).length;
    this.isAllSelectedStore = (allitemcount === checkeditemcount ? true : false);
  }
// Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
  // setSelectAllProductCategory() {
  //   const allitemcount = this.productCategoryList.length;
  //   const checkeditemcount = this.filteredProductCategoryList.filter(x => x.selected === true).length;
  //   this.isAllSelectedProductCategory = (allitemcount === checkeditemcount ? true : false);
  // }
// Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
  // setSelectAllProductName() {
  //   const allitemcount = this.productNameList.length;
  //   const checkeditemcount = this.filteredProductNameList.filter(x => x.selected === true).length;
  //   this.isAllSelectedProductName = (allitemcount === checkeditemcount ? true : false);
  // }

  // # Set Selection All End

  // # Set Toggle Selection All Start

  statetoggleSelectAll() {
    this.selectedState = [];
    this.isAllSelectedState = !this.isAllSelectedState;
    const len = this.filteredStateList.length;
    if (this.isAllSelectedState) {
      for (let i = 0; i < len; i++) {
        this.filteredStateList[i].selected = true;
        this.selectedState.push(this.filteredStateList[i]);
      }
      this.changeState(function (callback) {});
    } else {
      this.selectedState = [];
      this.filteredStateList.forEach(x => x.selected = this.isAllSelectedState);

      this.storeCategoryList = [];
      this.filteredStoreCategoryList = [];
      this.filteredStoreCategoryList = this.storeCategoryList;
      this.selectedStoreCategory = [];
      this.isAllSelectedStoreCategory = false;

      this.storecodeList = [];
      this.filteredStoreList = [];
      this.filteredStoreList = this.storecodeList;
      this.selectedStore = [];
      this.isAllSelectedStore = false;
    }
  }

  storeCategoryToggleSelectAll() {
    this.selectedStoreCategory = [];
    this.isAllSelectedStoreCategory = !this.isAllSelectedStoreCategory;
    const len = this.filteredStoreCategoryList.length;
    if (this.isAllSelectedStoreCategory) {
      for (let i = 0; i < len; i++) {
        //this.storetypeList[i].selected = true;
        this.filteredStoreCategoryList[i].selected = true;
        this.selectedStoreCategory.push(this.filteredStoreCategoryList[i]);
      }
      this.storeCategorychange(function (callback) {});
    } else {
      this.selectedStoreCategory = [];
      this.filteredStoreCategoryList.forEach(x => x.selected = this.isAllSelectedStoreCategory);
      this.storecodeList = [];
      this.filteredStoreList = [];
      this.filteredStoreList = this.storecodeList;
      this.selectedStore = [];
      this.isAllSelectedStoreCategory = false;
    }
  }

  storecodetoggleSelectAll() {
    this.selectedStore = [];
    this.isAllSelectedStore = !this.isAllSelectedStore;
    const len = this.filteredStoreList.length;
    if (this.isAllSelectedStore) {
      for (let i = 0; i < len; i++) {
        this.filteredStoreList[i].selected = true;
        this.selectedStore.push(this.filteredStoreList[i]);
      }
    } else {
      if (this.pageProperties.paramId > 0) {
        this.selectedStore = this.storecodeList.filter(e => e.storeDisabled === true);
        for (let i = 0; i < this.filteredStoreList.length; i++) {
          if (this.filteredStoreList[i].storeDisabled == true) {
            this.filteredStoreList[i].selected = true;
          }
          else {
            this.filteredStoreList[i].selected = false;
          }
        }
      }
      else {
        this.selectedStore = [];
        this.filteredStoreList.forEach(x => x.selected = this.isAllSelectedStore);
      }
    }
    this.setStoreCodeselectall();
  }

  // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
  // productCategorytoggleSelectAll(){
  //   this.selectedProductCategory = [];
  //   this.isAllSelectedProductCategory = !this.isAllSelectedProductCategory;
  //   const len = this.filteredProductCategoryList.length;
  //   if (this.isAllSelectedProductCategory) {
  //     for (let i = 0; i < len; i++) {
  //       this.filteredProductCategoryList[i].selected = true;
  //       this.selectedProductCategory.push(this.filteredProductCategoryList[i]);
  //     }
  //   } else {
  //     if (this.pageProperties.paramId > 0) {
  //       this.selectedProductCategory = this.productCategoryList.filter(e => e.storeDisabled === true);
  //       for (let i = 0; i < this.filteredProductCategoryList.length; i++) {
  //         if (this.filteredProductCategoryList[i].storeDisabled == true) {
  //           this.filteredProductCategoryList[i].selected = true;
  //         }
  //         else {
  //           this.filteredProductCategoryList[i].selected = false;
  //         }
  //       }
  //     }
  //     else {
  //       this.selectedProductCategory = [];
  //       this.filteredProductCategoryList.forEach(x => x.selected = this.isAllSelectedProductCategory);
  //     }
  //   }
  //   // this.setSelectAllProductCategory();
  // }

  // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
  // productNametoggleSelectAll(){
  //   this.selectedProductName = [];
  //   this.isAllSelectedProductName = !this.isAllSelectedProductName;
  //   const len = this.filteredProductNameList.length;
  //   if (this.isAllSelectedProductName) {
  //     for (let i = 0; i < len; i++) {
  //       this.filteredProductNameList[i].selected = true;
  //       this.selectedProductName.push(this.filteredProductNameList[i]);
  //     }
  //   } else {
  //     if (this.pageProperties.paramId > 0) {
  //       this.selectedProductName = this.productNameList.filter(e => e.storeDisabled === true);
  //       for (let i = 0; i < this.filteredProductNameList.length; i++) {
  //         if (this.filteredProductNameList[i].storeDisabled == true) {
  //           this.filteredProductNameList[i].selected = true;
  //         }
  //         else {
  //           this.filteredProductNameList[i].selected = false;
  //         }
  //       }
  //     }
  //     else {
  //       this.selectedProductName = [];
  //       this.filteredProductNameList.forEach(x => x.selected = this.isAllSelectedProductName);
  //     }
  //   }
  //   // this.setSelectAllProductName();
  // }

  // # Set Toggle Selection All End

  // # Change Event Start

  changeState(callback) {
    if (this.selectedState != null && this.selectedState.filter(e => e.selected === true).length > 0) {
      this.sharedService.customGetApi('scheme_new/storetypeList?stateNames=' + this.selectedState.filter(e => e.selected === true).map(a => a.name).join()).subscribe((t) => {
        if (t && t.data) {
          this.storeCategoryList = t.data.data;
          this.filteredStoreCategoryList = [];
          this.filteredStoreCategoryList = this.storeCategoryList;
          if (this.selectedStoreCategory != null && this.selectedStoreCategory.length > 0) {
            for (var i = 0; i < this.selectedStoreCategory.length; i++) {
              const index = this.storeCategoryList.findIndex(value => value.id === this.selectedStoreCategory[i].id);
              if (index >= 0) {
                this.storeCategoryList[index].selected = true;
                const findex = this.filteredStoreCategoryList.findIndex(value => value.id === this.selectedStoreCategory[i].id);
                if (findex >= 0) {
                  this.filteredStoreList[index].selected = true;
                }
              }
              else {
                this.selectedStoreCategory[i].selected = false;
              }
            }
            this.selectedStoreCategory = this.selectedStoreCategory.filter(e => e.selected == true);
            this.storeCategorychange(function (callback) { });
          }
          else {
            this.storecodeList = [];
            this.filteredStoreList = [];
            this.filteredStoreList = this.storecodeList;
            this.selectedStore = [];
          }
          this.setstoreCategoryselectall();
        }
      }, error => {
        this.notification.warning('Something went wrong');
      });
    }
    else {
      this.storeCategoryList = [];
      this.filteredStoreCategoryList = this.storeCategoryList;
      this.selectedStoreCategory = [];

      this.storecodeList = [];
      this.filteredStoreList = this.storecodeList;
      this.selectedStore = [];
    }
    callback(true);
  }

  storeCategorychange(callback) {
    if (this.selectedState != null && this.selectedState.filter(e => e.selected === true).length > 0 &&
      this.selectedStoreCategory != null && this.selectedStoreCategory.filter(e => e.selected === true).length > 0) {
      this.sharedService.customPostApi('loyaltyDiscount/storecodeList', {
        StateNames: this.selectedState.map(a => a.id).join(),
        StoreTypes: this.selectedStoreCategory.map(a => a.id).join()
      }).subscribe((t) => {
        if (t && t.data) {
          this.storecodeList = t.data;
          this.filteredStoreList = [];
          this.filteredStoreList = this.storecodeList;
          if (this.selectedStore != null && this.selectedStore.length > 0) {
            for (var i = 0; i < this.selectedStore.length; i++) {
              const index = this.storecodeList.findIndex(value => value.storeNo === this.selectedStore[i].storeNo);
              if (index >= 0) {
                this.storecodeList[index].selected = true;
                const findex = this.filteredStoreList.findIndex(value => value.storeNo === this.selectedStore[i].storeNo);
                if (findex >= 0) {
                  this.filteredStoreList[index].selected = true;
                }
              }
            }
          }
          this.setStoreCodeselectall();
        }
      }, error => {
        this.notification.warning('Something went wrong');
      });
    }
    else {
      this.storecodeList = [];
      this.filteredStoreList = [];
      this.filteredStoreList = this.storecodeList;
      this.selectedStore = [];
    }
    callback(true);
  }

  // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
  // changeProductCategory(callback) {
  //   if (this.selectedProductCategory != null && this.selectedProductCategory.filter(e => e.selected === true).length > 0) {
  //     this.loadProductName()
  //   }
  //   callback(true);
  // }

  trackById(index: number, item: any): number {
    return item.id;
  }

  // # Change Event End

  handlefromdate(event) {
    if (this.loyaltyDiscountform.get("loyaltyFromDate").value != null || this.loyaltyDiscountform.get("loyaltyFromDate").value != '') {
      this.setmintodate = new Date(this.loyaltyDiscountform.get("loyaltyFromDate").value);
    }
  }

  // # Control Filter Start

  private statefilter(filter: string): any[] {
    this.statelastFilter = filter;
    if (filter) {
      return this.statelist.filter(option => {
        return option.name != null && option.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
      });
    } else {
      if (this.statelist) {
        return this.statelist.slice();
      }
    }
  }

  private storeCategoryfilter(filter: string): any[] {
    this.storeCategorylastFilter = filter;
    if (filter) {
      return this.storeCategoryList.filter(option => {
        return option.storeType != null && option.storeType.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
      });
    } else {
      if (this.storeCategoryList) {
        return this.storeCategoryList.slice();
      }
    }
  }

  private storefilter(filter: string): any[] {
    this.storelastFilter = filter;
    if (filter) {
      return this.storecodeList.filter(option => {
        return option.storeName != null && option.storeName.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
      });
    } else {
      if (this.storecodeList) {
        return this.storecodeList.slice();
      }
    }
  }

  // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
  // private productCategoryfilter(filter: string): any[] {
  //   this.productCategorylastFilter = filter;
  //   if (filter) {
  //     return this.productCategoryList.filter(option => {
  //       return option.name != null && option.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
  //     });
  //   } else {
  //     if (this.productCategoryList) {
  //       return this.productCategoryList.slice();
  //     }
  //   }
  // }

  private productNamefilter(filter: string): any[] {
    this.productNamelastFilter = filter;
    if (filter) {
      return this.productNameList.filter(option => {
        return option.name != null && option.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
      });
    } else {
      if (this.productNameList) {
        return this.productNameList.slice();
      }
    }
  }

  // # Control Filter End

  // # General Event Start

  onSave(){
    if (Number(this.loyaltyDiscountform.get("totalMinimumBillDiscount").value) === 0){
      this.notification.error("Total minimum bill discount can't be zero!");
      return;
    }
    else if (Number(this.loyaltyDiscountform.get("rewardPointPerc").value) === 0) {
      this.notification.error("Reward point percentage can't be zero!");
      return;
    }
    else if (Number(this.loyaltyDiscountform.get("perRewardPointValue").value) === 0) {
      this.notification.error("Per reward point can't be zero!");
      return;
    }
    else if (Number(this.loyaltyDiscountform.get("earningcycleinmonth").value) === 0) {
      this.notification.error("Earning cycle in month can't be zero!");
      return;
    }
    else if (Number(this.loyaltyDiscountform.get("rewardPointExpiryDays").value) === 0) {
      this.notification.error("Reward point expiry days can't be zero!");
      return;
    }
    else if (this.loyaltyItemDataSource.data === null || this.loyaltyItemDataSource.data.length === 0){
      this.notification.error("You need to select atleast one product for loyalty discount!");
      return;
    }
    // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
    // else if (this.selectedProductName === null || this.selectedProductName.length === 0) {
    //   this.notification.error("You need to select atleast one product for loyalty discount!");
    //   return;
    // }
    // Comment: Added store code validation as it's compulsory to select atleast one storeCode
    else if (this.selectedStore === null || this.selectedStore.length === 0){
      this.notification.error("You need to select atleast one storeCode for loyalty discount!");
      return;
    }

    this.filteredStoreList.filter(e => e.selected === true).forEach(item => {
      var objloyalDiscMap = new clsloyaltyDiscountMapping();
      objloyalDiscMap.stateId = item.stateId;
      objloyalDiscMap.storeCategoryId = item.categoryId;
      objloyalDiscMap.storeCodeId = item.store_Id;
      objloyalDiscMap.itemCategoryId = 0;
      this.mappingList.push(objloyalDiscMap);
    });

    // this.filteredProductNameList.filter(e => e.selected === true).forEach(item => {
    // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
    this.loyaltyItemDataSource.data.forEach(item => {
      var objloyalDiscMap = new clsloyaltyDiscountMapping();
      objloyalDiscMap.stateId = 0;
      objloyalDiscMap.storeCategoryId = 0;
      objloyalDiscMap.storeCodeId = 0;
      objloyalDiscMap.itemCategoryId = item.mm_McmId;
      this.mappingList.push(objloyalDiscMap);
    });
    
    const distinctArray = this.mappingList.reduce((accumulator, current) => {
      if (!accumulator.some(item => item.stateId === current.stateId 
        && item.storeCategoryId === current.storeCategoryId 
        && item.storeCodeId === current.storeCodeId 
        && item.itemCategoryId === current.itemCategoryId)) {
        accumulator.push(current);
      }
      return accumulator;
    }, []);

    if (this.loyaltyDiscountform.valid) {
      this.sharedService.customGetApi('loyaltyDiscount/chkloyalexists?fromDate=' + DateService.formatDate(new Date(this.loyaltyDiscountform.get("loyaltyFromDate").value),'YYYY-MM-DD') + 
    '&toDate=' + DateService.formatDate(new Date(this.loyaltyDiscountform.get("loyaltyToDate").value),'YYYY-MM-DD')).subscribe((t: any) => {
      if (t.data.header.length > 0) {
        this.notification.error("Scheme already exists between period " + DateService.formatDate(new Date(this.loyaltyDiscountform.get("loyaltyFromDate").value),'DD-MM-YYYY') + " and " + DateService.formatDate(new Date(this.loyaltyDiscountform.get("loyaltyToDate").value),'DD-MM-YYYY') + "!");
        return;
      }
      else {
          this.sharedService.customPostApi('loyaltyDiscount/saveorupdateloyaltydiscount', {
            id: this.pageProperties.paramId,
            description: this.loyaltyDiscountform.get("loyaltyDesc").value,
            from_Month: DateService.getUTCDate(new Date(this.loyaltyDiscountform.get("loyaltyFromDate").value)),
            to_Month: DateService.getUTCDate(new Date(this.loyaltyDiscountform.get("loyaltyToDate").value)),
            isIncluded: this.loyaltyDiscountform.get("isIncluded").value,
            isBeforeTax: this.loyaltyDiscountform.get("isBeforeTax").value,
            totalMinimumBillPerMonth: this.loyaltyDiscountform.get("totalMinimumBillDiscount").value,
            rewardPointInPerc: this.loyaltyDiscountform.get("rewardPointPerc").value,
            perRewardPointValueToRs: this.loyaltyDiscountform.get("perRewardPointValue").value,
            earningCycleInMonth: this.loyaltyDiscountform.get("earningcycleinmonth").value,
            rewardPointExpDays: this.loyaltyDiscountform.get("rewardPointExpiryDays").value,
            includeReturn: this.loyaltyDiscountform.get("allowSalesReturn").value,
            isActive: this.loyaltyDiscountform.get("isActive").value,
            lstloyaltyDiscountMapping: distinctArray,
            // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
            lstloyaltyDiscountItemDetail: this.loyaltyItemDataSource.data //.filter(e => e.selected === true), //.map(a => a.id).join()
            // lstloyaltyDiscountItemDetail: this.selectedProductName.filter(e => e.selected === true), //.map(a => a.id).join()
           }).subscribe((t: any) => {
             if (t.status) {
                if (this.arrayOfObjects.length > 0) {  
                  let loyaltydiscountId = t.data;
                  this.sharedService.customPostApi('common/InsertfileLogUpdate', {
                    pageId: 177,
                    ref_Id: loyaltydiscountId,
                    fileName: this.csvfileName,
                    totalRecords: this.arrayOfObjects.length,
                    successRecords: this.matchArrayOfObject.length,
                    errorRecords: this.notMatchedArrayOfObjects.length,
                    errorCodeRecords: this.notMatchedArrayOfObjects.map(a => a.itemCode).join()
                  }).subscribe((t: any) => {
                  if (t.status) {
                    console.info("Log Saved Successfully!");
                  }
                 });
                }
                this.notification.success(t.message);
                this.activateRoute.navigate(['report/view/177']);
             }
             else {
               this.notification.error(t.message);
               this.savebuttondisable = false;
             }
           });
        }
      });
    }
  }

  validatePercentage(event: KeyboardEvent): void {
    const inputChar = event.key;
    const currentValue: string = this.loyaltyDiscountform.get("rewardPointPerc").value;

    // Allow backspace, delete, arrow keys, and tab
    if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(inputChar)) {
      return;
    }

    // Allow only digits and decimal point
    if (!/\d/.test(inputChar) && inputChar !== '.') {
      event.preventDefault();
      return;
    }

    // Prevent entering values greater than 100
    const newValue = currentValue + inputChar;
    if (parseFloat(newValue) > 100) {
      event.preventDefault();
    }

    const decimalPart = currentValue.split(".")[1];
    if (decimalPart && decimalPart.length >= 2) {
      event.preventDefault();
    }
  }

  onCancel(){
    this.dialogRef = this.sharedService.getConfirmatonConfig(ConfirmationHeader.Confirmation, 'Are you sure want to discard all selected details?', ButtonType.YesNo);
     this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.statelist.forEach(e => e.selected = false);
        this.filteredStateList = [];
        this.filteredStateList = this.statelist;
        this.selectedState = [];
        this.setStateselectall();

        if (this.filteredStoreCategoryList != null || this.filteredStoreCategoryList != undefined) {
          this.storeCategoryList.forEach(e => e.selected = false);
          this.filteredStoreCategoryList = [];
          this.filteredStoreCategoryList = this.storeCategoryList;
          this.selectedStoreCategory = [];
          this.setstoreCategoryselectall();
        }

        if (this.filteredStoreList != null || this.filteredStoreList != undefined) {
          this.storecodeList.forEach(e => e.selected = false);
          this.filteredStoreList = [];
          this.filteredStoreList = this.storecodeList;
          this.selectedStore = [];
          this.setStoreCodeselectall();
        }

        // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
        // if (this.filteredProductCategoryList != null || this.filteredProductCategoryList != undefined) {
        //   this.productCategoryList.forEach(e => e.selected = false);
        //   this.filteredProductCategoryList = [];
        //   this.filteredProductCategoryList = this.productCategoryList;
        //   this.selectedProductCategory = [];
        //   // this.setSelectAllProductCategory();
        // }

        // if (this.filteredProductNameList != null || this.filteredProductNameList != undefined) {
        //   this.productNameList.forEach(e => e.selected = false);
        //   this.filteredProductNameList = [];
        //   this.filteredProductNameList = this.productNameList;
        //   this.selectedProductName = [];
        //   // this.setSelectAllProductName();
        // }

        // this.productCategoryControl.reset();
        // this.productNameControl.reset();
        // this.productCategoryControl.setValue('');
        // this.productNameControl.setValue('');
        // this.productCategorylastFilter = '';
        // this.loyaltyDiscountform.reset();
        // this.loyaltyDiscountform.get('productCategoryControl').setValue(0);
        // this.productCategoryControl.valueChanges.pipe(
        //   startWith<string | any[]>(''),
        //   map(value => typeof value === 'string' ? value : this.productCategorylastFilter),
        //   map(filter => this.productCategoryfilter(filter))
        // ).subscribe(data => this.filteredProductCategoryList = data);
        // this.productNameControl.setValue('');
        // this.productCategoryControl.setValue('');

        // this.bindForm(null);
        // this.loyaltyDiscountform.reset();

        // this.loyaltyDiscountform.setValue({
        //   productCategoryControl: '',
        //   productNameControl: ''
        // });
      }
    });
  }

  // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
  ngAfterViewInit(): void {
    this.loyaltyItemDataSource.paginator = this.paginator;
  }

  onBack() {
    this.dialogRef = this.sharedService.getConfirmatonConfig(ConfirmationHeader.Confirmation, 'Are you sure want to close this form?', ButtonType.YesNo);
    this.dialogRef.afterClosed().subscribe(result => {
      if (!isNullOrUndefined(result) && result === true) {
        this.activateRoute.navigate(['report/view/177']);
      }
    });
  }

  downlodCSV() {
    let columns: string[] = ['itemCode'];
    this.sharedService.generateCsvWithColumnsOnly(columns);
  }

  // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
  readCSVFile (event: any) {
    //this.sharedService;
    const file = event.target.files[0];
    this.csvfileName = file.name;
    this.uploadedFile = this.csvfileName;
    if (file) {
      const reader = new FileReader();
      reader.readAsText(file);
      reader.onload = () => {
        this.csvData = reader.result as string;  // Store the file content in csvData
        this.arrayOfObjects = this.sharedService.convertCsvToArrayOfObjects(this.csvData);  // Call method to convert CSV to array of objects
        const invalidAlphNumericValue  = this.sharedService.validateFieldType(this.arrayOfObjects, 'itemCode', 'alphanumeric');

        if (invalidAlphNumericValue.length > 0) {
          this.notification.error("Invalid item Code Found : " + invalidAlphNumericValue);
          return;
        }

        this.arrayOfObjects = this.arrayOfObjects.filter(a => a.itemCode != "");
        if (this.productNameList.length > 0 && this.totalProductLength === this.productNameList.length) {
          this.notMatchedArrayOfObjects = this.sharedService.getNonMatchingObjectsByProperty(this.arrayOfObjects, this.productNameList, "itemCode", "code");
          this.matchArrayOfObject = this.arrayOfObjects.filter(obj1 => 
            !this.notMatchedArrayOfObjects.some(obj2 => obj1["itemCode"] === obj2["itemCode"])
          );
          // this.dataForPopupMsg = [];
          this.totalRecordCount = this.arrayOfObjects.length;
          this.successRecordCount = this.matchArrayOfObject.length;
          this.failureRecordCount = this.notMatchedArrayOfObjects.length;
          this.failureRecords = [... new Set(this.notMatchedArrayOfObjects.map(a => a.itemCode))].join();
          
          this.toggleModal(true);
          // this.filteredProductNameList = this.productNameList;

          // this.filteredProductNameList.filter(allProd => this.matchArrayOfObject.some(selectedProd => allProd["code"] === selectedProd["itemCode"])).forEach(element => {
          //   this.filteredProductCategoryList.filter(a => a["id"] === element["mm_McmId"]).forEach(ele => {
          //     if (this.selectedProductCategory.filter(e => e["id"] === ele["id"]).length === 0) {
          //         this.selectedProductCategory.push(ele);
          //         ele["selected"] = true;
          //       }
          //     });

          //     if (this.selectedProductName.filter(a => a["id"] === element["id"]).length === 0) {
          //       this.selectedProductName.push(element);
          //       element["selected"] = true;
          //     }
          // });
          
          if (!isNullOrUndefined(this.loyaltyItemDataSource.data)) {
            this.loyaltyItemDataSource.data = [];
          }

          this.loyaltyItemDataSource.data = this.productNameList.filter(prod => this.matchArrayOfObject.some(selectedProd => prod["code"] === selectedProd["itemCode"])).map((prod, index) => ({
            srno: index + 1,  // Add serial number starting from 1
            ...prod              // Spread the original product properties
          }));;
        }
        else {
          this.notification.warning("Please wait for product to get load!");
          return;
        }
      }
    }
    event.target.value = '';
    this.arrayOfObjects = [];
    this.notMatchedArrayOfObjects = [];
    this.matchArrayOfObject = [];
  }

 // Method to toggle modal visibility
  toggleModal(value: boolean): void {
    this.showModal = value;
  }

  // Method to close the modal
  closeModal(): void {
    this.toggleModal(false);
  }
  
  // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
  onRowDelete(item) {
    this.dialogRef = this.sharedService.getConfirmatonConfig(ConfirmationHeader.Confirmation, 'Are you sure want to delete ?', ButtonType.YesNo);
    this.dialogRef.afterClosed().subscribe(result => {
      if (!isNullOrUndefined(result) && result === true) {
        const index: number = this.loyaltyItemDataSource.data.indexOf(item);
        if (index !== -1) {
          this.loyaltyItemDataSource.data.splice(index, 1);
          this.loyaltyItemDataSource.data.forEach((item, idx) => {
            item.srno = idx + 1;
          });
          this.loyaltyItemDataSource.data = this.loyaltyItemDataSource.data;
        }
      }
    });
  }

  // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
  // Check if all rows are selected
  isAllSelected() {
    return this.loyaltyItemDataSource.data.length === this.selectedItems.size;
  }

  // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
  // Toggle select/deselect all
  toggleAll() {
    if (this.isAllSelected()) {
      this.selectedItems.clear(); // Deselect all if all are selected
    } else {
      this.loyaltyItemDataSource.data.forEach(item => this.selectedItems.add(item.id)); // Select all items
    }
  }

  // Git Id: 82  Developer: Pankaj Motwani  Date: 16-04-2025 
  // Toggle individual row selection
  toggleRowSelection(row: any) {
    if (this.selectedItems.has(row.id)) {
      this.selectedItems.delete(row.id); // Deselect the item
    } else {
      this.selectedItems.add(row.id); // Select the item
    }
  }
  // # General Event End
}

class clsloyaltyDiscountMapping {
  stateId: number;
  storeCategoryId: number;
  storeCodeId: number;
  itemCategoryId: number;
}
// class clsUploadCSV {
//   total_Records: number;
//   success_Records: number; 
//   failed_Records: number;
//   failed_Record_Items: string;
// }